import  React, { useState, useEffect} from 'react';
import axios from 'axios';
import { config } from "../../../enviroment";
import  {ApplePayButton}  from 'react-apple-pay-button';
import moment from 'moment';
import { setFingerPrintId } from './fingerPrintId';
import { history } from "../../../helpers/history";
import { store } from "../../../helpers/store";
import { routePaths } from '../../config/route-paths';

function ApplePayButtonShow({ state, disabled, nsaClick }) {
    console.log(state)
  const [aPayConfig, setAPayConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(true);
  const [confirmation, setConfirmation] = useState(null); // State for confirmation message
  const [showConfirmation, setShowConfirmation] = useState(false);
  let demographicDetails = store?.getState()?.accountInformation?.demographicDetails;
  let bearer = localStorage.getItem("bearer") ,emailId="", userName = "", sessionId = "";
  useEffect(() => {
    const fetchAPayConfig = async () => {
      try {
        setConfigLoading(true);
        const response = await axios.get(config.urls.USAGE_SERVICE_URL + '/apple-pay/config');
        setAPayConfig(response.data);
        setConfigLoading(false);
      } catch (error) {
        setConfigLoading(false);
        console.error('Error fetching Apple Pay config:', error);
      }
    };
    fetchAPayConfig();
  }, []);
  let transactionInfo;
  function fixNames(firstName, lastName) {
    firstName = firstName?.trim();
    lastName = lastName?.trim();
    if (!lastName) {
      const nameParts = firstName.split(' ');
      if (nameParts.length > 1) {
        lastName = nameParts.pop();
        firstName = nameParts.join(' ');
      } else {
        lastName = firstName;
      }
    }

    return { firstName, lastName };
  }
  if (bearer) {
    bearer = JSON.parse(bearer);
    // emailId = bearer?.email;
    userName = bearer?.userName;
    sessionId = bearer?.sessionId;
  }
  let enableButton
  if(state?.source === "QUICK_PAY") {
    let connections
    let enteredEmail = localStorage.getItem('email');
    let landingEmail = localStorage.getItem('landing');
    landingEmail=JSON.parse(landingEmail);
    let temp = enteredEmail ?? landingEmail?.emailId
    if(state?.connectionId && state?.amount) {
      connections = [{ ConnectionId: state?.connectionId, Amount: Number(parseFloat(state?.amount).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2
      })}]
    }
    transactionInfo = {
      totalPriceStatus: 'FINAL',
      totalPrice: state?.amount?.toString(),
      currencyCode: 'QAR',
      countryCode: 'QA',
      userName: userName,
      sessionId: sessionId,
      connections: connections || [],
      mobile: state?.phoneNum?.replace(/[()\s+]/g, ''),
      email: temp,
      city: state?.city,
      firstName: fixNames(state?.firstName, state?.lastName)?.firstName || "",
      lastName: fixNames(state?.firstName, state?.lastName)?.lastName || "",
      premise: state?.premiseAddress?.split(',').slice(0, 3).join(',').trim(),
      source: "QUICK_PAY"
    }
    enableButton = transactionInfo?.connections?.length > 0 && Number(transactionInfo?.totalPrice) > 0;
  } else if(state?.source === "SERVICE_PAY") {
    enableButton = Number(state?.amount?.toString()) > 0;
    let connections
    let userEmail = localStorage.getItem('email');
    let landingRes = localStorage.getItem('landing');
    landingRes=JSON.parse(landingRes);
    let temp2 = userEmail ?? landingRes?.emailId
    if(state?.connectionId && state?.amount) {
      connections = [{ ConnectionId: state?.connectionId, Amount: Number(parseFloat(state?.amount).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2
      })}]
    }
    transactionInfo = {
      totalPriceStatus: 'FINAL',
      totalPrice: state?.amount?.toString(),
      currencyCode: 'QAR',
      countryCode: 'QA',
      userName: userName,
      sessionId: sessionId,
      connections: connections || [],
      mobile: state?.phoneNum?.replace(/[()\s+]/g, ''),
      email: temp2,
      city: state?.city,
      firstName: fixNames(state?.firstName, state?.lastName)?.firstName || "",
      lastName: fixNames(state?.firstName, state?.lastName)?.lastName || "",
      premise: state?.premiseAddress?.split(',').slice(0, 3).join(',').trim(),
      source: "SERVICE_PAY"
    }
  } else {
    return;
  }
  // let enableButton = transactionInfo?.connections?.length > 0 && Number(transactionInfo?.totalPrice) > 0;
  const handleError = (error) => {
    console.log(error)
    if (error instanceof Error) {
      console.error('JavaScript Error:', error.message, error.stack);
    } else {
      console.error('Apple Pay Error:', error.statusCode, error.statusMessage);
    }
  };
    const   onApplePayButtonClicked = () => {


      



        if (window.ApplePaySession) {
              const request = {
                  countryCode: 'QA',
                  currencyCode: 'QAR',
                  merchantCapabilities: ['supports3DS'],
                  supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
                  total: {
                      label: 'Qatar Cool',
                      type: 'final',
                      amount: transactionInfo.totalPrice
                  },
              };
            let session
            try{
              session = new window.ApplePaySession(3, request);
            }
            catch (error) {
              console.error("Failed to start Apple Pay session:", error);
            }
            session.onvalidatemerchant = async (event) => {
                try {
                    console.log("Valid merchant",event.validationURL)
                    const merchantSession = await axios.post(config.urls.BASE_URL + '/usage/apple-pay/validate-merchant', {
                        validationURL: event.validationURL
                    });
                    session.completeMerchantValidation(merchantSession.data);
                } catch (error) {
                    console.error('Error validating merchant:', error);
                }
            };

            session.onpaymentmethodselected = (event) => {
                console.log("onpaymentmethodselected")
                const update = {
                    // Example: You could update the total based on the selected payment method
                    newTotal: {
                        label: "Total",        // Label for the line item
                        amount: transactionInfo.totalPrice     // Amount in QAR (or your currency)
                    }
                };

                session.completePaymentMethodSelection(update);
            };

            session.onpaymentauthorized = async (event) => {
                try {
                    console.log("onpaymentauthorized", event.payment.token)
                    const paymentData = event.payment.token;
                    await handleLoadPaymentData(paymentData)
                    const authorizationResult = {
                                status: window.ApplePaySession.STATUS_SUCCESS,
                        };
                    session.completePayment(authorizationResult);
                    session.completePayment(window.ApplePaySession.STATUS_SUCCESS,);
                } catch (error) {
                    console.error('Payment failed:', error);
                    session.completePayment({ status: window.ApplePaySession.STATUS_FAILURE });
                }
            };

            session.oncancel = () => {
                console.log('Apple Pay session was canceled.');
            };
            // Start the Apple Pay session
            session.begin();
        } else {
            console.error('Apple Pay is not available on this browser!');
        }       
    };



    const handleLoadPaymentData = async (paymentData) => {
      const premiseAddress = [
        paymentData?.shippingAddress?.address1,
        paymentData?.shippingAddress?.address2,
        paymentData?.shippingAddress?.address3,
      ]
      .filter((line) => line)
      .join(", ");
      if(paymentData.shippingAddress){
      transactionInfo = {
        ...transactionInfo,
        email:  paymentData.email,
        mobile: paymentData.shippingAddress.phoneNumber,
        city: paymentData.shippingAddress.locality,
        premise: premiseAddress
      }}
      const recipentEmailForQuickPay = localStorage.getItem("email")
      paymentData.email = recipentEmailForQuickPay ? recipentEmailForQuickPay : transactionInfo.email
      let assigningEmail = recipentEmailForQuickPay ? recipentEmailForQuickPay : transactionInfo.email;
      if(nsaClick) {
        try {
          transactionInfo = {...transactionInfo, orderId: generateOrderId(true), email:assigningEmail }
          let res = await nsaClick(transactionInfo.orderId)
          console.log(res)
          setFingerPrintId("");
          history.push({
            pathname: routePaths.APPLE_PAY_PROCESS,
            state: { paymentData, transactionInfo, gatewayConfig: aPayConfig }
          });
        } catch(error) {
  
        }
      } else {
        transactionInfo = {...transactionInfo, orderId: generateOrderId(), email: assigningEmail}
        setFingerPrintId("");
        history.push({
          pathname: routePaths.APPLE_PAY_PROCESS,
          state: { paymentData, transactionInfo, gatewayConfig: aPayConfig }
        });
      }
    };
      const generateOrderId = () => {
        return "APAY-" + transactionInfo.connections[0]['ConnectionId'] + moment(new Date()).format("DDMMYYYYHHmmssSS");
      }
      if (configLoading) {
        return <div>Loading Apple Pay...</div>;
      }
      // if (!aPayConfig) {
      //   return <></>
      // }
      // if (aPayConfig.enableGateway !== "true") {
      //   return <></>
      // }
    return (
        <div style={ (disabled || !enableButton) ? {pointerEvents: "none", opacity: "0.5", borderRadius: '8px', border: "1px solid gray", } 
        : { border: "1px solid gray", borderRadius: '4px'}}>
             <ApplePayButton
                onClick={onApplePayButtonClicked}
               
                // disabled
                // style={ {pointerEvents: "none", } }
                // style={ (disabled || !enableButton) ? {pointerEvents: "none", opacity: "0.5", borderRadius: '8px',  } : {}}
                type="continue"
                onError={handleError}  // Handle Apple Pay errors
            > &nbsp;</ApplePayButton>
        </div>
    );
}

export default ApplePayButtonShow;
